import { Box, Typography, Chip } from "@mui/material"
import { useRoutePermission } from "../context/RoutePermissionContext"
import { useNavigate } from "react-router-dom"

const ErrorFallback = () => {
    const { allMenuLinks, currentRole } = useRoutePermission()
    const navigate = useNavigate()
    const hasHistory = window.history.length > 1
    const firstLink = allMenuLinks?.[0]
    const hasNoPermissions = !allMenuLinks || allMenuLinks.length === 0

    return (
        <Box className="e-error-container">
            {/* SVG */}
            <svg width="260" height="180" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#e53935" strokeWidth="2" />
                <path d="M12 7v5" stroke="#e53935" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="16" r="1" fill="#e53935" />
            </svg>

            <Typography variant="h4" className="e-error-title">
                {hasNoPermissions ? "No Access" : "Something went wrong"}
            </Typography>

            {hasNoPermissions ? (
                <Box className="e-error-card">
                    <Typography variant="body1" mb={2}>
                        You do not have any permissions assigned for this application.
                        Please contact your administrator to get access.
                    </Typography>

                    {currentRole && (
                        <Typography variant="body2" mb={2}>
                            [ Role: <b style={{ color: "#1976d2" }}>{currentRole}</b> ]
                        </Typography>
                    )}
                </Box>
            ) : (
                /* ✅ Allowed Links Section */
                <Box className="e-error-card">
                    <Typography variant="body1" mb={2}>
                        Based on your current role as a Manager, we've listed your authorized pages
                        below. Please select a destination to continue:
                    </Typography>

                    {currentRole && (
                        <Typography variant="body2" mb={2}>
                            [ Role: <b style={{ color: "#1976d2" }}>{currentRole}</b> ]
                        </Typography>
                    )}

                    <Box className="e-error-links">
                        {allMenuLinks.map((link) => (
                            <Chip
                                key={link?.link}
                                label={
                                    <span className="e-error-chip-label">
                                        {link?.title}
                                        <span className="e-error-chip-icon">↗</span>
                                    </span>
                                }
                                onClick={() => navigate(link?.link)}
                                clickable
                                className="e-error-chip"
                            />
                        ))}
                    </Box>
                </Box>
            )}

            {/* Buttons */}
            <Box display="flex" gap={2}>
                <button
                    className="e-go-back-btn"
                    onClick={() => {
                        if (hasNoPermissions) {
                            navigate("/")
                        } else if (hasHistory) {
                            navigate(-1)
                        } else if (firstLink?.link) {
                            navigate(firstLink.link)
                        }
                    }}
                >
                    {hasNoPermissions
                        ? "Back to Apps"
                        : hasHistory
                          ? "Go Back"
                          : `Go to ${firstLink?.title || "Home"}`}
                </button>
            </Box>
        </Box>
    )
}

export default ErrorFallback
